module.exports = __webpack_public_path__ + "static/media/HeRecibido-Prestamo.01453ca3.png";